import script from "./EmptyPane.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyPane.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyPane.vue?vue&type=style&index=0&id=fea5176e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fea5176e"]])

export default __exports__